import { Component } from '@angular/core';
import { SpControlBaseDirective } from '@shared/directives/sp-control-base/sp-control-base.directive';

@Component({
  selector: 'sp-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['../input/style.scss', './date-input.component.scss'],
})
export class DateInputComponent extends SpControlBaseDirective {
  updateValidation() {
    this.errorMessage = this.formControl.dirty
      ? Object.entries(this.formControl.errors ?? {})
          .map(([validation, param]) => {
            switch (validation) {
              case 'required':
                return `${this.inputLabel} cannot be empty`;
              default:
                return param;
            }
          })
          .shift()
      : '';
  }
}
